import React from "react";
import BoldButton from "./bold-button";
import ItalicButton from "./italic-button";
import UnderlineButton from "./underline-button";
import {RichTextTool, TextFormats} from "./tools-types.enum";
import {TextFormatType} from "lexical";

interface FormattingGroupProps {
    activeFormats: {
        bold: boolean;
        italic: boolean;
        underline: boolean;
    };
    onFormatChange: (command: TextFormatType) => void;
    hiddenOptions?: RichTextTool[];
}

const FormattingGroup: React.FC<FormattingGroupProps> = ({activeFormats, onFormatChange, hiddenOptions = []}) => {
    return (
        <>
            {!hiddenOptions.includes(TextFormats.BOLD) && (
                <BoldButton isActive={activeFormats.bold} onFormat={() => onFormatChange(TextFormats.BOLD)}/>
            )}
            {!hiddenOptions.includes(TextFormats.ITALIC) && (
                <ItalicButton isActive={activeFormats.italic} onFormat={() => onFormatChange(TextFormats.ITALIC)}/>
            )}
            {!hiddenOptions.includes(TextFormats.UNDERLINE) && (
                <UnderlineButton isActive={activeFormats.underline}
                                 onFormat={() => onFormatChange(TextFormats.UNDERLINE)}/>
            )}
        </>
    );
};

export default FormattingGroup;
